import React, { Component, Children } from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './radio-button.module.css'

const propTypes = {
    disabled: PropTypes.bool,
    name: PropTypes.string,
    onChange: PropTypes.func,
    value: PropTypes.string
}

const defaultProps = {
    disabled: false,
    onChange() {}
}

class RadioGroup extends Component {
    constructor(props) {
        super(props)
        this.state = {
            value: props.value
        }

        Object.defineProperty(this, 'value', {
            get: () => this.state.value
        })

        this.onChangeRadioButton = this.onChangeRadioButton.bind(this)
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({ value: nextProps.value })
    }

    render() {
        const { value } = this.state
        const { children, className, disabled } = this.props

        if (Children.count(children) < 2) {
            throw new Error('A Radio Button group needs to have at least 2 Radio Buttons!')
        }

        const radioElements = React.Children.map(children, (child, index) =>
            React.cloneElement(child, {
                checked: child.props?.value === value,
                disabled: child.props?.disabled || this.props.disabled,
                key: index,
                name: this.props?.name,
                onChange: this.onChangeRadioButton
            })
        )

        const classNameMerged = cx(
            styles['radio-group'],
            {
                [styles['disabled']]: disabled
            },
            className
        )

        return <ul className={classNameMerged}>{radioElements}</ul>
    }

    onChangeRadioButton(event) {
        const { value } = event.target
        this.setState({ value: value }, () => this.props.onChange(value))
    }
}

RadioGroup.propTypes = propTypes
RadioGroup.defaultProps = defaultProps

export { RadioGroup }
